

























import { Component, Inject, Vue } from "vue-property-decorator";
import {
  IClientProviderData,
  IClientProviderMethods
} from "@/models/providers/client";

@Component
export default class Client2faContextualise extends Vue {
  // Inject

  @Inject({ from: "clientProvider" })
  public readonly $clientProvider!: () => IClientProviderData;

  @Inject({ from: "clientMethods" })
  public readonly $clientMethods!: IClientProviderMethods;

  // Data

  public isProcessing = false;

  // Computed

  public get $clientData() {
    return this.$clientProvider();
  }

  // Methods

  public async disable2FA() {
    if (this.isProcessing) return;
    if (!this.$userCan("disable_client_2fa")) return;
    this.isProcessing = true;
    const isDisabled = await this.$clientMethods.disable2Fa();
    if (isDisabled) {
      this.$buefy.toast.open({
        message: this.$t("_.2fa_successfully_disabled") as string
      });
    }
    this.isProcessing = false;
  }
}
